//@dependencies
import PropTypes from "prop-types";
//styles
import styles from "./Popup.module.scss";
import { CircularProgress, Grid2 } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../CustomButton/CustomButton";
import { CP } from "../../Utils/roconConstants";

export default function ModalPopup(props) {
  //props and hooks
  const {
    trigger,
    closePopup,
    backPopup,
    children,
    header,
    removed,
    nextpopup,
    nextOnClick,
    backOnClick,
    loading,
    disabled,
    customWidth,
    customPopupLeft,
    ...rest
  } = props;

  return trigger ? (
    <Grid2
      {...rest}
      className={styles.NewpopupContainer}
      style={{ left: customPopupLeft }}
    >
      <Grid2 className={styles.containerStyles}>
        <Grid2
          className={styles.popupDomainContainer}
          style={{ width: customWidth }}
        >
          <Grid2 className={styles.DomainContainer}>
            <Grid2 {...rest} item className={styles.addDomainHeader}>
              <Grid2 className={styles.header}>{header}</Grid2>
              {closePopup ? (
                removed ? (
                  ""
                ) : (
                  <Grid2
                    onClick={() => {
                      closePopup();
                    }}
                  >
                    <CloseIcon className={styles.popupCloseButton} />
                  </Grid2>
                )
              ) : (
                ""
              )}
            </Grid2>
            <Grid2 className={styles.line} />
            <Grid2 className={styles.children}>{children}</Grid2>
          </Grid2>
          <Grid2 className={styles.buttonContainer}>
            <Grid2 className={styles.backPopup} onClick={backOnClick}>
              {backPopup}
            </Grid2>
            <CustomButton
              className={styles.nextpopup}
              onClick={nextOnClick}
              disabled={disabled}
            >
              {loading ? (
                <CircularProgress size={CP.SIZE} color={CP.COLOR} />
              ) : (
                nextpopup
              )}
            </CustomButton>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  ) : null;
}

//types
ModalPopup.propTypes = {
  trigger: PropTypes.bool,
  closePopup: PropTypes.func,
  backPopup: PropTypes.string,
  nextpopup: PropTypes.string,
  children: PropTypes.node,
  header: PropTypes.string,
  nextOnClick: PropTypes.func,
  backOnClick: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};
